import axios from 'axios'
import { arrayToQueryString } from '@utils/url'
import { ErrorWrapper } from '@utils/error-handler'
export const state = {
  dashboardList: [],
}

export const getters = {}

export const mutations = {
  CACHE_DASHBOARD_LIST(state, newList) {
    state.dashboardList = newList
  },
}

export const actions = {
  fetchDashboardList({ commit, state, rootState }, { filter }) {
    return axios
      .get(
        `${
          process.env.VUE_APP_API_BASE_URL
        }/dashboard/admin?${arrayToQueryString(filter)}`
      )
      .then((response) => {
        const list = response.data
        commit('CACHE_DASHBOARD_LIST', list)
        return list
      })
      .catch((error) => {
        return new ErrorWrapper(error)
      })
  },
}
